import { ECorporationResourceGroups } from "common/enums/CorporationSheet/Groups/ECorporationResourceGroups";
import ClientSheetUpdateBeneficiaryRequestResource from "common/resources/ClientSheet/ClientSheetUpdateBeneficiaryRequestResource";

export function synchronizeRepresentativeBeneficiary(
	beneficiaries: ClientSheetUpdateBeneficiaryRequestResource[],
	representative: ClientSheetUpdateBeneficiaryRequestResource,
): ClientSheetUpdateBeneficiaryRequestResource[] {
	if (!representative.clientId) return beneficiaries;
	return beneficiaries.map((beneficiary) => beneficiary.clientId === representative.clientId
		? ClientSheetUpdateBeneficiaryRequestResource.hydrate<ClientSheetUpdateBeneficiaryRequestResource>({
			...representative,
			pourcentageParts: beneficiary.pourcentageParts,
		}, { groups: [ECorporationResourceGroups.beneficiaries] })
		: beneficiary);
}
